import { Component, OnInit,ViewChild, HostListener, ChangeDetectorRef } from '@angular/core';
import {MdbTableDirective, MdbTablePaginationComponent} from 'angular-bootstrap-md';
import { AdsService } from '../../services/ads.service';

@Component({
  selector: 'app-user-ads',
  templateUrl: './user-ads.component.html',
  styleUrls: ['./user-ads.component.scss']
})
export class UserAdsComponent implements OnInit {
  adsList:any = []
  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, {static: true}) mdbTable: MdbTableDirective;

  headElements = ['Ad Name', 'Image', 'Description','Redirection URL', 'Package', 'Action'];
  searchText: string = '';
  previous: string;

  cancellationReason: boolean;
  cancellationArray:any = [];


  constructor(private adsService: AdsService, private cdRef: ChangeDetectorRef) { }

  @HostListener('input') oninput() {
    this.searchItems();
}

  ngOnInit(): void {
    this.adsService.getAllAdsUser().then((res:any) => {
      // console.log(res.ads.data)
      this.adsList=res.ads.data
      console.log(this.adsList)
      this.mdbTable.setDataSource(this.adsList);
      this.previous = this.mdbTable.getDataSource();
    })
  }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(10);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  searchItems() {
    const prev = this.mdbTable.getDataSource();
    if (!this.searchText) {
        this.mdbTable.setDataSource(this.previous);
        this.adsList = this.mdbTable.getDataSource();
    }
    if (this.searchText) {
        this.adsList = this.mdbTable.searchLocalDataBy(this.searchText);
        this.mdbTable.setDataSource(prev);
    }
}

  deleteAdUser(){
    this.adsService.deleteAdUser(this.cancellationArray.id).then((res:any) => {
      console.log(res)
      this.adsService.getAllAdsUser().then((res:any) => {
        // console.log(res.ads.data)
        this.adsList=res.ads.data
        console.log(this.adsList)
        this.mdbTable.setDataSource(this.adsList);
        this.previous = this.mdbTable.getDataSource();
      })
      this.cancellationReason = false;
    })
  }

  showCancellation(id) {
    this.cancellationReason = true;
    this.cancellationArray.id = id;
    console.log(this.cancellationArray.id)
  
  }
  
  hideCancellation() {
    this.cancellationReason = false;
  }

}
